module.exports = __webpack_public_path__ + "media/images/chat-fill-f381825d.svg";